import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import Services from './components/Services';
import Partners from './components/Partners';
import About from './components/About';
import ContactForm from './components/ContactForm';
import Footer from './components/Footer';
import CreatorRegistrationPage from './pages/CreatorRegistrationPage';

const stats = [
  { value: '180+', label: 'Campaigns launched' },
  { value: '3x', label: 'Average ROI growth' },
  { value: '94%', label: 'Client retention rate' },
  { value: '24/7', label: 'Performance monitoring' },
];

const advantages = [
  {
    title: 'Performance-Driven Strategy',
    description: 'Every campaign is built around measurable growth, clear KPIs, and sustainable results that scale with your business.',
  },
  {
    title: 'Creative That Converts',
    description: 'We build messaging and visuals that speak to your audience, capture attention, and turn clicks into leads.',
  },
  {
    title: 'Smart Reporting',
    description: 'You get transparent insights, optimization recommendations, and reporting that helps you make smart decisions faster.',
  },
  {
    title: 'End-to-End Execution',
    description: 'From strategy and content to media buying and optimization, we own the full growth engine for your brand.',
  },
];

const testimonials = [
  {
    quote: 'RT Jobspot helped us sharpen our digital presence and gave us a stronger, more efficient acquisition funnel.',
    person: 'Marketing Lead',
    company: 'Fintech Brand',
  },
  {
    quote: 'Their team understood our audience quickly and improved our campaign quality with practical, data-led execution.',
    person: 'Growth Manager',
    company: 'E-commerce Startup',
  },
  {
    quote: 'The communication, strategy, and reporting were excellent. We finally had clarity on what was working and where to scale.',
    person: 'Business Owner',
    company: 'Service Business',
  },
];

const OldMarketingPage = () => (
  <>
    <Header />
    <HeroSection />

    <section id="results" className="bg-white py-16">
      <div className="mx-auto max-w-6xl px-4">
        <div className="mb-10 text-center">
          <p className="mb-3 text-sm font-semibold uppercase tracking-[0.2em] text-primary-light">Trusted Growth Partner</p>
          <h2 className="text-3xl font-extrabold text-primary-dark md:text-4xl">Results that speak for themselves</h2>
        </div>

        <div className="grid gap-6 md:grid-cols-2 xl:grid-cols-4">
          {stats.map((stat) => (
            <div key={stat.label} className="rounded-2xl border border-slate-200 bg-slate-50 p-6 text-center shadow-sm transition duration-300 hover:-translate-y-1 hover:shadow-xl">
              <div className="mb-2 text-4xl font-black text-primary-dark">{stat.value}</div>
              <p className="text-base font-medium text-slate-600">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>

    <Services />

    <section id="why-us" className="bg-slate-50 py-16">
      <div className="mx-auto max-w-6xl px-4">
        <div className="mb-10 text-center">
          <p className="mb-3 text-sm font-semibold uppercase tracking-[0.2em] text-primary-light">Why choose us</p>
          <h2 className="text-3xl font-extrabold text-primary-dark md:text-4xl">Built for sustainable digital growth</h2>
        </div>

        <div className="grid gap-6 md:grid-cols-2 xl:grid-cols-4">
          {advantages.map((item) => (
            <div key={item.title} className="rounded-2xl bg-white p-6 shadow-md ring-1 ring-slate-200 transition duration-300 hover:-translate-y-1 hover:shadow-xl">
              <div className="mb-4 h-12 w-12 rounded-xl bg-primary/10 flex items-center justify-center text-xl text-primary-dark">✓</div>
              <h3 className="mb-3 text-xl font-bold text-primary-dark">{item.title}</h3>
              <p className="text-slate-600">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>

    <Partners />

    <section id="testimonials" className="bg-white py-16">
      <div className="mx-auto max-w-6xl px-4">
        <div className="mb-10 text-center">
          <p className="mb-3 text-sm font-semibold uppercase tracking-[0.2em] text-primary-light">Client feedback</p>
          <h2 className="text-3xl font-extrabold text-primary-dark md:text-4xl">What clients say about working with us</h2>
        </div>

        <div className="grid gap-6 lg:grid-cols-3">
          {testimonials.map((item) => (
            <div key={item.person} className="rounded-2xl border border-slate-200 bg-slate-50 p-6 shadow-sm">
              <div className="mb-4 text-3xl text-primary-light">“</div>
              <p className="mb-6 text-slate-700">{item.quote}</p>
              <div className="border-t border-slate-200 pt-4">
                <div className="font-bold text-primary-dark">{item.person}</div>
                <div className="text-sm text-slate-500">{item.company}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>

    <About />
    <ContactForm />
    <Footer />
  </>
);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<OldMarketingPage />} />
        <Route path="/creator-registration" element={<CreatorRegistrationPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
